module.exports = __webpack_public_path__ + "img/uam.6742612a.jpg";